import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["fill"]
const _hoisted_2 = ["stroke"]


export default /*#__PURE__*/_defineComponent({
  __name: 'ShoppingCart',
  props: {
  fillColor: {
    type: String,
    required: false,
    default: 'white',
  },
  strokeColor: {
    type: String,
    required: false,
    default: 'white',
  },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: __props.fillColor,
    class: "mb-1.5 mt-4",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _createElementVNode("path", {
      d: "M6.25 6.25H8.41667L8.85 8.41667M10.5833 17.0833H21.4167L25.75 8.41667H8.85M10.5833 17.0833L8.85 8.41667M10.5833 17.0833L8.09937 19.5673C7.4169 20.2498 7.90025 21.4167 8.8654 21.4167H21.4167M21.4167 21.4167C20.2201 21.4167 19.25 22.3867 19.25 23.5833C19.25 24.78 20.2201 25.75 21.4167 25.75C22.6133 25.75 23.5833 24.78 23.5833 23.5833C23.5833 22.3867 22.6133 21.4167 21.4167 21.4167ZM12.75 23.5833C12.75 24.78 11.78 25.75 10.5833 25.75C9.38672 25.75 8.41667 24.78 8.41667 23.5833C8.41667 22.3867 9.38672 21.4167 10.5833 21.4167C11.78 21.4167 12.75 22.3867 12.75 23.5833Z",
      stroke: __props.strokeColor,
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, 8, _hoisted_2)
  ], 8, _hoisted_1))
}
}

})